import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Home from './pages/Home/Home';
import Identidad from './pages/Identidad/Identidad';
import Servicios from './pages/Servicios/Servicios';
import Proyectos from './pages/Proyectos/Proyectos';
import Contacto from './pages/Contacto/Contacto';
import Direccion from './pages/Direccion/Direccion';
import Gestion from './pages/Gestion/Gestion';
import Compromisos from './pages/Compromisos/Compromisos';

import LoadingScreen from './components/LoadingScreen';
import './styles/globals.css';

// Componente optimizado para scroll
const ScrollHandler = React.memo(() => {
  const location = useLocation();

  const handleScroll = useCallback(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, []);

  useEffect(() => {
    handleScroll();
  }, [location.pathname, handleScroll]);

  return null;
});

// Wrapper optimizado para rutas
const OptimizedRoutes = React.memo(() => {
  const routes = useMemo(() => (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/quienes-somos" element={<Identidad />} />
      <Route path="/servicios" element={<Servicios />} />
      <Route path="/negocios" element={<Servicios />} />
      <Route path="/proyectos" element={<Proyectos />} />
      <Route path="/contacto" element={<Contacto />} />
      <Route path="/direccion" element={<Direccion />} />
      <Route path="/gestion" element={<Gestion />} />
      <Route path="/compromisos" element={<Compromisos />} />
    </Routes>
  ), []);

  return routes;
});

function App() {
  const [initialLoading, setInitialLoading] = useState(true);

  // Optimizar scroll performance al montar la app
  useEffect(() => {
    // Deshabilitar smooth scrolling durante la carga inicial
    document.documentElement.style.scrollBehavior = 'auto';
    
    // Optimizaciones de performance
    const optimizeRendering = () => {
      // Forzar reflow inicial para estabilizar el layout
      // eslint-disable-next-line no-unused-expressions
      const height = document.documentElement.offsetHeight;
      console.log('Layout optimized:', height);
      
      // Re-habilitar smooth scrolling después de que todo esté cargado
      setTimeout(() => {
        document.documentElement.style.scrollBehavior = 'smooth';
      }, 1000);
    };

    // Loading inicial de la aplicación
    const loadingTimer = setTimeout(() => {
      setInitialLoading(false);
    }, 2000); // 2 segundos de loading inicial

    // Ejecutar optimizaciones cuando todo esté listo
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', optimizeRendering);
    } else {
      optimizeRendering();
    }

    // Cleanup
    return () => {
      clearTimeout(loadingTimer);
      document.removeEventListener('DOMContentLoaded', optimizeRendering);
    };
  }, []);

  // Mostrar loading screen inicial
  if (initialLoading) {
    return <LoadingScreen />;
  }

  return (
    <Router>
      <div className="App">
        <ScrollHandler />
        <Header />
        <main className="main-content">
          <OptimizedRoutes />
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;